import { createContext } from 'react';
export const SelectedContentContext = createContext({
    allIsSelected: false,
    moduleIsIndeterminate: () => false,
    selectModule: () => { },
    selectPage: () => { },
    selectAll: () => { },
    selectedModules: {},
    selectedPages: {},
    hasPublished: false,
    hasUnpublished: false,
    selectedContentCount: 0,
    selectedModuleIds: [],
    selectedPageIds: []
});
